"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  $(Dom.modalBtn).on("click", function (event) {
    event.preventDefault();
    handlers.openModal($(this));
  });
  $(Dom.closeModalBtn).on("click", function (event) {
    event.preventDefault();
    handlers.closeModal();
  });
  $(Dom.overlay).on("click", function (event) {
    event.preventDefault();
    handlers.closeModal();
  });
};
